export default __webpack_public_path__ + "static/media/paste-file.563704f8.svg";